import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  UpdateCommissionFeeRequestDto,
  UpdateCommissionFeeResponseDto,
  UpdateUserDetailsRequestDto,
  UpdateUserDetailsResponseDto,
} from '@sparling/financial-common'

export const canUpdateUserData = createAction('CAN_UPDATE_USER_DATA')<boolean>()

export const {
  request: updateUserCommissionFeeRequest,
  success: updateUserCommissionFeeSuccess,
  failure: updateUserCommissionFeeFailure,
} = createAsyncAction(
  'UPDATE_USER_COMMISSION_FEE_REQUEST',
  'UPDATE_USER_COMMISSION_FEE_SUCCESS',
  'UPDATE_USER_COMMISSION_FEE_FAILURE',
)<{ idSf: string } & UpdateCommissionFeeRequestDto, UpdateCommissionFeeResponseDto, Error>()

export const {
  request: updateUserDetailsRequest,
  success: updateUserDetailsSuccess,
  failure: updateUserDetailsFailure,
} = createAsyncAction('UPDATE_USER_DETAILS_REQUEST', 'UPDATE_USER_DETAILS_SUCCESS', 'UPDATE_USER_DETAILS_FAILURE')<
  UpdateUserDetailsRequestDto & { idSf: string },
  UpdateUserDetailsResponseDto,
  Error
>()
